export default {
    acura_canada: 'Acura Canada',
    activix: 'Activix CRM',
    api: 'API',
    auto_renewal: '@.capitalize:lexicon.renewal.singular automatique',
    bmw_canada: 'BMW Canada',
    cdk: 'CDK',
    cloning: 'Dupliquer',
    ct_wizard: 'CTWizard',
    dealer_vu: 'DealerVu',
    easydeal: 'EasyDeal',
    f_c_a_digital: 'FCA Digital',
    ford_direct: 'FordDirect',
    gm_canada: 'GM Canada',
    honda_canada: 'Honda Canada',
    kia_digital: 'Kia Digital',
    m_b_c_a_digital: 'MBCA Digital',
    manual: 'Manuel',
    manual_import: 'Import manuel',
    n_c_i_digital: 'NCI Digital',
    niotext: 'NioText',
    pbs: 'PBS',
    phone_system: 'Sys. Tél.',
    call_log: 'Sys. Tél. API',
    porsche_digital: 'Porsche Digital',
    porsche_finder: 'Porsche Finder',
    polaris_digital: 'Polaris Digital',
    harley_davidson_digital: 'Harley Davidson Digital',
    maserati_digital: 'Maserati Digital',
    scan: 'Scan Xpress',
    taq_auto: 'Taq Auto',
    scraper: 'Intégrateur',
    serti: 'Serti',
    stellantis_digital: 'Stellantis Digital',
    undefined: '-',
    messenger: 'Messenger',
    polestar: 'Polestar',
    mitsubishi: 'Mitsubishi',
    prebooking: 'Pré-booking automatique',
    one_eighty: 'One-Eighty',
    hyundai: 'Hyundai',
};
